import React, { useEffect, useState } from 'react';
import { Form, Button, Alert, Spinner, Col, Row, Container, Table } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { postDataLogin, postData } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import { CiSearch } from "react-icons/ci";
import LatestInterviews from './LatestInterviews';
import ClientsPage from './ClientsPage';
import AddJobPostPage from './AddJobPostPage';
import { FaCircleCheck } from "react-icons/fa6";
import { FaJ } from "react-icons/fa6";
import { FaC } from "react-icons/fa6";
import { FaT } from "react-icons/fa6";
import { FaCode } from 'react-icons/fa';
import { FaLaptopCode } from "react-icons/fa";

const JobPost = () => {
  const navigate = useNavigate();
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const selectFromDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  const selectToDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  const [validated, setValidated] = useState(false);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [fromDate, setFromDate] = useState(selectFromDate);
  const [toDate, setToDate] = useState(selectToDate);
  const [jobDetails, setJobDetails] = useState({
    cid: '',
    jobName: '',
    jobDescription: '',
    jobSkills: '',
    openingCount: '',
    fromDate: fromDate,
    toDate: toDate,
    createdBy: aminInfo?.user_id,
    client_id: ''
  });
  const [jobFlag, setJobFlag] = useState(true);
  const [latestTestFlag, setLatestTestFlag] = useState(false);
  const [jobList, setJobList] = useState([]);
  const [latestInterviewsList, setLatestInterviewsList] = useState([]);
  const [postJobFlag, setPostJobFlag] = useState(false);
  const [filteredData, setFilteredData] = useState(jobList);
  const [pjSuccess, setPjSuccess] = useState('');
  const [selectCategory,setSelectCategory]=useState('TECHNOLOGY')

  const addedJobs = () => {
    setPjSuccess('')
    setSuccess('')
    setJobFlag(true);
    setLatestTestFlag(false);
    setPostJobFlag(false);
    listOfJobs()
  }
  const clickJobDetails = (event) => {
    
    navigate(`/jobdetails?id=${event.job_id}`, { state: { jobDetails: event } });

  }
  const addCandidate = (event) => {
    navigate(`/candidate`, { state: { jobId: event } });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobDetails((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
  };
  useEffect(()=>{
    selectCategoryChange(selectCategory)
  },[jobList])

  const [isCategory, setisCategory] = useState(false);
  const selectCategoryChange=async (event)=>{
    console.log("event",event)
    setSelectCategory(event);
    setCurrentPage(1)
    if(event === 'TECHNOLOGY'){
      const filteredJobs = jobList.map((job) => {
        const clientName = job && job.client_category && job.client_category;
      
        if (!clientName) {
          // If client_category is empty, add "TECHNOLOGY"
          // console.log('clientName',clientName)
          job.client_category = "TECHNOLOGY";
        }
      
        return job;
      }).filter((job) => {
        // Filter the jobs based on your criteria (e.g., matching event)
        return job.client_category && job.client_category.includes(event);
      });
      console.log('filteredJobs',filteredJobs)
      if(filteredJobs.length > 0 ){
        setisCategory(false);
      }else{
        setisCategory(true);
      }
      setFilteredData(filteredJobs.length > 0 ? filteredJobs : jobList);
      setSearchData(filteredJobs.length > 0 ? filteredJobs : jobList);
    }else{
      const filteredJobs = jobList.filter((job) => {
        // job.job_client.toLowerCase().includes(searchTerm.toLowerCase())
        const clientName = job && job.client_category && job.client_category;
       
        return clientName && clientName.includes(event);
      });
      console.log('filteredJobs',filteredJobs)
      if(filteredJobs.length > 0 ){
        setisCategory(false);
      }else{
        setisCategory(true);
      }
      setFilteredData(filteredJobs.length > 0 ? filteredJobs : jobList);
      setSearchData(filteredJobs.length > 0 ? filteredJobs : jobList);
    }

    

  }

  const [clientList, setClientList] = useState([])

  // useEffect(() => {
  //   getClientList()
  // }, [])

  const getClientList = async () => {
    const payload = {
      "user_id": aminInfo?.user_id
    }

    try {
      await postData('admin_in/clients/clients-list', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                if (respData.dataJ.length > 0) {
                 
                  setClientList(respData.dataJ);
                  setLoading(false);
                  //setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setSuccess(resp.info);
                }
              } else {
                setLoading(false);
                setSuccess(resp.info);
              }
            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(resp.info);
            } else {
              setLoading(false);
              setSuccess('Job Details failed. Please check your credentials.');

            }
          } else if (resp.status === 401 || resp.status === 403) {
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
              //   callRefreshTokenApi('getSfeBatch', '');
            }
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSuccess('JobDetails failed. Please check your credentials or Network Error');
          }
        }).catch((error) => {
          console.log('network error:', error);
          setLoading(false);
          setSuccess('JobDetails failed. Please check your credentials or Network Error');

        });
      }).catch((error) => {
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error');
        console.log('network error:', error);
      });
    } catch (error) {
      console.error('Job Details failed', error);
      setLoading(false);
      setSuccess('JobDetails failed. Please check your credentials or Network Error');
    }

  }

  const handleClientChange = (e) => {
    console.log('value')
    setJobDetails()


  }

  const [searchData, setSearchData] = useState([])
  const handleSearch = async (e) => {
    console.log("filtered",filteredData)
    e.preventDefault();
    setSearchData(filteredData)
    console.log("name",e)
    if (searchTerm.trim() === '') {
      setFilteredData(filteredData);
    } else {
      const filteredJobs = filteredData.filter((job) => {
        // job.job_client.toLowerCase().includes(searchTerm.toLowerCase())
        const clientName = job && job.job_name && job.job_name?.toLowerCase();
       
        return clientName && clientName.includes(searchTerm?.toLowerCase());
      });
      setFilteredData(filteredJobs.length > 0 ? filteredJobs : filteredData);
    }
    
  };

  const submitButton = async () => {
    setLoading(true);
    setSearchTerm('')
    setJobFlag(true)
    setLatestTestFlag(false)
    setPostJobFlag(false)
    // e.preventDefault();
    setJobList([]);
    setSuccess('');
    setPjSuccess('')
    const payload = {
      // "company_id": aminInfo?.organization_id,
      "company_id": aminInfo?.organization_id,
      "user_id": aminInfo?.user_id,
      "from_date": fromDate,
      "to_date": toDate

    };
    //   setLoading(true)
    // return
    try {
      await postData('admin_in/job/get-jobs-list', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                if (respData.dataJ.length > 0) {
                  setJobList(respData.dataJ);
                  selectCategoryChange('TECHNOLOGY')
                  setLoading(false);
                  //setSuccess(resp.info)
                } else {
                  setLoading(false);
                  setSuccess(resp.info);

                }
              } else {
                setLoading(false);
                setSuccess(resp.info);

              }
            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(resp.info);
            } else {
              setLoading(false);
              setSuccess('Job Details failed. Please check your credentials.');
            }
          } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            setLoading(false);
            console.log('resp status else if @@@@@ : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {
                setLoading(false);
                setSuccess('Looks like Token Expired Please Login');
              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setSuccess('Looks like Token Expired Please Login');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSuccess('Job Details failed. Please check your credentials!');
          }
        }).catch((error) => {
          console.log('network error:', error);
          setLoading(false);
          setSuccess('Job Details failed. Please check your credentials!!');

        });
      }).catch((error) => {
        console.log("catch22",error)
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error!');
        console.log('catch error:', error);
      });
    } catch (error) {
      setLoading(false);
      setSuccess('JobDetails failed. Please check your credentials or Network Error!!');
      console.log('try catch error:', error);
    }
  }



  const openPostJob = () => {
    setSearchTerm('')
    setPostJobFlag(true);
    setJobFlag(false);
    setLatestTestFlag(false)
    setFilteredData(jobList)
    setPjSuccess('')
    setSuccess('')
  }

  useEffect(() => {
    listOfJobs();
  }, [])

  const listOfJobs = async () => {
    setPjSuccess('')
    setSuccess('')
    setSearchTerm('')
    setJobFlag(true)
    setLatestTestFlag(false)
    setPostJobFlag(false)
    // e.preventDefault();
    setJobList([]);
    const payload = {
      // "company_id": aminInfo?.organization_id,
      "company_id": aminInfo?.organization_id,
      "user_id": aminInfo?.user_id

    }; 
    setLoading(true)
    // return
    try {
      await postData('admin_in/job/get-jobs-list', payload).then(resp => {
        resp.json().then(respData => {
          if (resp.status === 200) {
            if (respData.statusCode === 200) {
              if (respData.message.toLowerCase() === 'success') {
                setJobList(respData.dataJ);                
                selectCategoryChange(respData?.client_category_default)
                setSelectCategory(respData?.client_category_default)
                // setFilteredData(respData.dataJ);
                setLoading(false);
                if (respData.dataJ.length === 0) {
                  setSuccess("Created Jobs are not found")
                }
                //setSuccess(resp.info);
              } else {
                setLoading(false);
                setSuccess(respData.info);
              }

            } else if (respData.statusCode === 500) {
              setLoading(false);
              setSuccess(respData.info);
            } else {
              setLoading(false);
              setSuccess('Job Details failed. Please check your credentials.');
            }
          }
          else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
            setLoading(false);
            console.log('resp status else if : ', resp.status);
            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
              || respData.message === 'Access Denied') {

              //   callRefreshTokenApi('getSfeBatch', '');
            }
            setisCategory(false);
            setSuccess('Looks Like Session Expired Please login..');
          } else {
            console.log('resp status else  : ', resp);
            setLoading(false);
            setSuccess('Job Details failed. Please check your credentials!');
          }
        }).catch((error) => {
          console.log('network error:', error);
          setLoading(false);
          setSuccess('Job Details failed. Please check your credentials!!');

        });

      }).catch((error) => {
        setLoading(false);
        setSuccess('JobDetails failed. Please check your credentials or Network Error');
        console.log('network error:', error);

      });
    } catch (error) {
      setLoading(false);
      // Handle login error, e.g., display an error message to the user.
      console.error('Job Details failed', error);
    }
  }


  const clickltsInterview = async (e) => {
    setPjSuccess('')
    setSuccess('')
    setSearchTerm('')
    setFilteredData(jobList)
    setJobFlag(false)
    setLatestTestFlag(true)
    setPostJobFlag(false)
    e.preventDefault();

  }

  const jobFormStyle = {
    background: 'white',
    padding: '20px',
    width: '100%',
    maxWidth: '590px',
    borderRadius: '10px',
    margin: 'auto',
    marginTop: '15px'
  }
  const gridRowStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
    borderBottom: ' 1px solid #ddd',
    margin: '2px'
  }
  const buttonStyling = {
    flex: '1',
    padding: '8px',
    borderRight: ' 1px solid #ddd',
    cursor: 'pointer',
    border: '1px solid #ddd',
    backgroundColor: jobFlag ? '#000' : '#fff',
    color: jobFlag ? '#fff' : '#000',
    fontWeight: '400'
  }
  const buttonStylings = {
    flex: '1',
    padding: '8px',
    borderRight: ' 1px solid #ddd',
    cursor: 'pointer',
    border: '1px solid #ddd',
    backgroundColor: latestTestFlag ? '#000' : '#fff',
    color: latestTestFlag ? 'white' : '#000',
    fontWeight: '400'

  }
  const postJobButton = {
    flex: '1',
    padding: '8px',
    borderRight: ' 1px solid #ddd',
    cursor: 'pointer',
    border: '1px solid #ddd',
    backgroundColor: postJobFlag ? '#000' : '#fff',
    color: postJobFlag ? 'white' : '#000',
    fontWeight: '400'
  }
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'new':
        return 'orange';
      case 'inprogress':
        return 'green';
      case 'closed':
        return 'red';
      default:
        return 'black'; // default color, you can change it as needed
    }
  };

  const [sortOrder, setSortOrder] = useState('asc');
  const [sortOrderById, setSortOrderById] = useState('asc');
  const [sortOrderClient,setSortOrderClient]=useState('asc')
  // const [sortedData, setSortedData] = useState(filteredData);

  const toggleSortOrder = (sortedValue) => {
    if (sortedValue === 'jobname') {
      const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
      setSortOrder(newSortOrder);

      // Sort the data based on the current sort order
      const sorted = [...filteredData].sort((a, b) => {
        const nameA = a.job_name.toUpperCase();
        const nameB = b.job_name.toUpperCase();

        if (newSortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // setSortedData(sorted);
      setFilteredData(sorted);
    }else if(sortedValue === 'clientname'){
      const newSortOrder = sortOrderClient === 'asc' ? 'desc' : 'asc';
      setSortOrderClient(newSortOrder);

      // Sort the data based on the current sort order
      const sortedClient = [...filteredData].sort((a, b) => {
        const nameA = a.client_name.toUpperCase();
        const nameB = b.client_name.toUpperCase();

        if (newSortOrder === 'asc') {
          return nameA.localeCompare(nameB);
        } else {
          return nameB.localeCompare(nameA);
        }
      });

      // setSortedData(sorted);
      setFilteredData(sortedClient);
    }
     else {
      const newSortOrder = sortOrderById === 'asc' ? 'desc' : 'asc';
      setSortOrderById(newSortOrder);

      const sortedData = filteredData.sort((a, b) => {
        const compareResult = sortOrderById === 'asc' ? a.job_id.localeCompare(b.job_id) : b.job_id.localeCompare(a.job_id);
        return compareResult;
      });

      setFilteredData(sortedData);
    }



  };

  const [selectedPageCount, setSelectedPageCount] = useState(10);

  const handleJobsPerPage = (event) => {
    setSelectedPageCount(event.target.value);
    setCurrentPage(1)
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = selectedPageCount; // Set the number of items per page

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const pageRange = 2; // Number of page buttons to show on each side of the current page

  const getPageRange = () => {
    const start = Math.max(1, currentPage - pageRange);
    const end = Math.min(totalPages, currentPage + pageRange);

    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  // const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  // const [currentItems, setCurrentItemsList] = useState(filteredData.slice(indexOfFirstItem, indexOfLastItem));
  // useEffect(()=>{
  //   setCurrentItemsList(filteredData.slice(indexOfFirstItem, indexOfLastItem))
  // },[filteredData])

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const YourComponent = ({ job, index }) => {
    const statusColor = getStatusColor(job.job_status);
    const [showMore, setShowMore] = useState(false);

    const statusStyles = {
      color: statusColor,
    };

    return (
      <tr key={index}>
        <td style={{ paddingLeft: '15px', textAlign: 'end' }}>{index + 1}</td>
        <td >
          {job.client_category ? <Link to={`/jobdetails?id=${job.job_id}&category=${job.client_category}`} style={{ textDecoration: 'none', color: 'blue' }}>
            {job.job_name} </Link>:
           <Link to={`/jobdetails?id=${job.job_id}&category=TECHNOLOGY`} style={{ textDecoration: 'none', color: 'blue' }}>
              {job.job_name} </Link>}
        </td>
        <td>{job.job_rec_id}</td>
        <td>{job.client_name}</td>
        {/* <td>
          {job.jd_questions_type === 1 && <span className='jd-qns'><FaJ className=' color-green icon-q' /><div className="jd-text">JD Questions</div> </span>}
          {job.recuiter_questions_type === 1 && <span className='client-qns'><FaC className=' color-green icon-q' /><div className="client-text">Client Questions</div> </span>}
          {job.ai_question_type === 1 && <span className='tech-qns'><FaT className=' color-green icon-q' /><div className="tech-text">Tech Questions</div></span>}
          {job?.coding_q_enabled === 1 && <span className='tech-qns'><FaLaptopCode className=' color-green icon-q' /><div className="tech-text">Coding Questions</div></span>}
          
        </td> */}
        <td style={{textTransform:'capitalize'}}>{job?.client_category?.toLowerCase()}</td>

        {/* <td>
          {job.jd_questions_type === 1 && <div>JD <span><FaJ  className='font-size-12 color-green' /></span></div>}
          {job.recuiter_questions_type === 1 && <div>Client <span><FaC  className='font-size-12 color-green' /></span></div>}
          {job.ai_question_type === 1 && <div>Tech <span><FaT  className='font-size-12 color-green' /></span> </div>}
        </td> */}
        <td style={{ textAlign: 'end' }}>{job.openings_count}</td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', textAlign: 'end' }}>
              {job.interviews_total}
            </div>
            <div className=' col-6 col-md-6' style={{ textAlign: 'end' }}>
              {job.interviews_done}
            </div>
          </div>
        </td>
        {(selectCategory !== 'HOSPITALITY' && selectCategory !== 'HEALTH_CARE')&&(
        <td>
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', textAlign: 'end' }}>
              {job.coding_interviews_total}
            </div>
            <div className=' col-6 col-md-6' style={{ textAlign: 'end' }}>
              {job.coding_interviews_done}
            </div>
          </div>
        </td>
        )}
        {/* <td style={{textAlign:'end'}}>{job.interviews_total}</td>
        <td style={{textAlign:'end'}}>{job.interviews_done}</td> */}
        {/* <td>{job.job_start_date}</td> */}
        {/* <td>{job.job_end_date}</td> */}
        {/* <td style={statusStyles}>{job.job_status}</td> */}
        {/* <td>{job.job_skills}</td> */}
        {/* <td>
          <div>{job.jd_of_candidate_input}</div>
          <div><span className='info-data'>
                          {showMore
                            ? job?.jd_of_candidate_input || ""
                            : job?.jd_of_candidate_input
                              ? job.jd_of_candidate_input.substring(0, 200)
                              : ""}
                          {job?.jd_of_candidate_input && job.jd_of_candidate_input.length > 200 && (
                            <button className="text-show-btn" onClick={() => setShowMore(!showMore)}> {showMore ? 'Show less':'Show more'} </button>
                          )}
                        </span></div>
          {job.ai_question_type === 1 && <div> <span className='color-font-w'>Technologies:</span> Selected Technologies Available. </div>}
          {job.recuiter_questions_type === 1 && <div><span className='color-font-w'>Client Questions:</span> {job.recuiter_questions_input}</div>}
        </td> */}
        {(selectCategory !== 'HOSPITALITY' && selectCategory !== 'HEALTH_CARE')&&(
        <td>
          {/* <Link to={`/candidate?id=${job.job_id}`} style={{ textDecoration: 'none', color: 'blue' }}>
            Schedule Interview
          </Link> */}
          <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}>
            <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', textAlign: 'center' }}>
              {job?.jd_questions_type || job?.ai_question_type || job?.recuiter_questions_type ?  <Link to={`/candidate?id=${job.job_id}&exam_type=THEORY`} style={{ textDecoration: 'none', color: 'blue' }}>
              Skills
          </Link>: <span style={{ color: '#73737c' }}>Skills</span>}          
            </div>
            <div className=' col-6 col-md-6' style={{ textAlign: 'center' }}>
              {job?.coding_q_enabled ? (<>
                <Link to={`/candidate?id=${job.job_id}&exam_type=CODING`} style={{ textDecoration: 'none', color: 'blue' }}>
            Coding
          </Link>
              </>):(<>
              <span style={{ color: '#73737c' }}>Coding</span>
              </>)}

            </div>
          </div>
        </td>
        )}
        {(selectCategory === 'HOSPITALITY' || selectCategory === 'HEALTH_CARE')&&(
          <td>
             {/* <div style={{ display: 'flex', flexDirection: 'row', margin: '0px' }}> */}
            <div  style={{  textAlign: 'center' }}>
              {job?.jd_questions_type || job?.ai_question_type || job?.recuiter_questions_type ?  <Link to={`/candidate?id=${job.job_id}&exam_type=THEORY`} style={{ textDecoration: 'none', color: 'blue' }}>
              Schedule
          </Link>: <span style={{ color: '#73737c' }}>Schedule</span>}          
            </div>
            {/* </div> */}
          </td>
        )}


      </tr>
    );
  };


  return (
    <div className='dashboard-div ' style={{ overflowX: 'hidden' }}>
      <NavHeader></NavHeader>
      <div className=''>

        <div className='page-title-heading'></div>
        {/* <div style={{textAlign:'center',marginTop:'25px',marginLeft:'50px',marginRight:'50px',marginBottom:'20px'}}>
            <div style={gridRowStyle} className='col-md-8 col-10'>
                <div style={buttonStyling} onClick={addedJobs}>All Jobs</div>
                <div style={postJobButton}  onClick={openPostJob}>Add New Job</div>
                <div style={buttonStylings}  onClick={clickltsInterview}>Manage Clients</div>
            </div>
          </div> */}

        {/* All Job div start */}
        {jobFlag && (
          <div className='row'>
            <div className='col-lg-3 col-md-9 col-9'>
              <Form onSubmit={handleSearch}>
                <div className='list-tech-div' style={{ marginLeft: '50px', padding: '0px', marginRight: '20px', marginBottom: '10px' }}>
                  <Form.Group style={{ height: '30px' }} className='input-width'>
                    <Form.Control type="text" placeholder=" Search by job name...." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value);console.log("event",e.target.value); if (e.target.value.length === 1 || e.target.value.length === 0) {console.log("filtered@",filteredData); setFilteredData(searchData) } }} style={{ background: 'white', padding: '4px' }} />
                  </Form.Group>
                  <Button type="submit" className='tech-submit' variant='dark' style={{ marginLeft: '5px', width: '80px', padding: '4px' }} onSubmit={handleSearch}> Search</Button>
                </div>
              </Form>
            </div>
            <div className='col-lg-4 col-md-4 col-12 client-button-container'style={{ textAlign: 'end',marginBottom:'10px' }} >
            <select name="selectCategory" value={selectCategory} onChange={(e)=> {selectCategoryChange(e.target.value)}} required  className='page-no-dropdown' style={{height:'35px',width:'190px'}}>
              <option value="" disabled> Select Category</option>
              <option value="TECHNOLOGY">Technology</option>
              <option value="HOSPITALITY">Hospitality</option>
              <option value="HEALTH_CARE">Health Care</option>
              {/* <option>All</option> */}
            </select >

            </div>
            <div className='col-lg-2 col-md-4 col-12 col-sm-4' style={{ textAlign: 'end',marginBottom:'10px' }}>
              <label htmlFor="dropdown" style={{padding:'5px'}}>Jobs per Page:</label>
              <select className='page-no-dropdown' id="dropdown" value={selectedPageCount} onChange={handleJobsPerPage}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="75">75</option>
                <option value="100">100</option>
              </select>
            </div>
            <div className='col-lg-3 col-md-4 col-12 col-sm-4'  style={{ textAlign: 'center',marginBottom:'10px' }}>
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        className='page-nation-btn'
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>

                      {getPageRange().map((page) => (
                        <button
                          key={page}
                          onClick={() => paginate(page)}
                          className='page-nation-btn'
                          style={{
                            backgroundColor: page === currentPage ? '#007BFF' : 'white',
                            color: page === currentPage ? 'white' : 'black',
                          }}
                        >
                          {page}
                        </button>
                      ))}

                      <button
                        onClick={() => paginate(currentPage + 1)}
                        className='page-nation-btn'
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
            
            {/* <div className='col-lg-2 col-md-4 col-12 col-sm-4'>
              <Form>
                <div className='list-tech-div' style={{ marginLeft: '50px', padding: '0px', marginRight: '20px', marginBottom: '10px' }}>
                  <legend className="scheduler-border-ing">
                    <div className="" style={{ backgroundColor: '#EDF2FB', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>From Date:</div>
                  </legend>
                  <Form.Group style={{ width: '200px' }}>
                    <Form.Control type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={{ background: 'white' }} />
                  </Form.Group>
                </div>
              </Form>
            </div> */}
            {/* <div className='col-lg-2 col-md-4 col-12 col-sm-4'>
              <Form>
                <div className='list-tech-div' style={{ marginLeft: '50px', padding: '0px', marginRight: '20px', marginBottom: '10px' }}>
                  <legend className="scheduler-border-ing">
                    <div className="" style={{ backgroundColor: '#EDF2FB', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>To Date:</div>
                  </legend>
                  <Form.Group style={{ width: '200px' }}>
                    <Form.Control type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={{ background: 'white' }} />
                  </Form.Group>
                </div>
              </Form>
            </div> */}
            {/* <div className='col-lg-2 col-md-3 col-4 col-sm-4' style={{ textAlign: 'left' }}>
              <Button variant="dark" onClick={submitButton} className='submit-button'>
                Submit
              </Button> */}
            {/* <Form>
                    <div className='list-tech-div' style={{marginLeft:'50px',padding:'0px',marginRight:'20px',marginBottom:'10px'}}>
                        <Form.Group style={{width:'200px'}}>
                            <Form.Control type="date"   value={toDate} onChange={(e) => setToDate(e.target.value)} style={{background:'white'}} />
                        </Form.Group>
                    </div>
                </Form> */}
            {/* </div> */}
          </div>)}
        {jobFlag && (
          <div className='tables-div'>
            <Row className='tables-div'>
              <Col>
                {success && <Alert variant="danger">{success}</Alert>}
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                {currentItems.length > 0 ? (
                  <div className="table-responsive">
                    <Table striped bordered hover>
                      <thead>
                        <tr style={{ backgroundColor: '#EDF2FB' }}>
                          <th style={{ textAlign: 'end', color: '#345687' }}>##</th>
                          <th onClick={() => toggleSortOrder('jobname')} style={{ cursor: 'pointer', color: '#345687' }} ><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}>Job Name </span> <span>{sortOrder === 'asc' ? ' ▲' : ' ▼'} </span></span></th>
                          <th onClick={() => toggleSortOrder('jobid')} style={{ color: '#345687', cursor: 'pointer' }}><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}>Job ID</span><span>{sortOrderById === 'asc' ? ' ▲' : ' ▼'}</span></span> </th>
                          <th onClick={() => toggleSortOrder('clientname')} style={{ width: '10%', color: '#345687',cursor:'pointer' }}><span style={{ display: 'flex' }}> <span style={{ flex: 'auto' }}> Client Name</span> <span>{sortOrderClient === 'asc' ? ' ▲' : ' ▼'}</span></span></th>


                          {/* <th style={{ width: 120, color: '#345687' }}>Questions</th> */}
                          <th style={{ width: 120, color: '#345687' }}>Category</th>
                          <th style={{ textAlign: 'end', color: '#345687' }}>Openings</th>
                          <th style={{ color: '#345687' }} className='text-center'>Skills Interviews <br />
                            <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                              <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#345687' }}>Scheduled</div>
                              <div className="col-6 col-md-6" style={{ color: '#345687' }}>Completed</div>
                            </div>
                          </th>
                          {(selectCategory !== 'HOSPITALITY' && selectCategory !== 'HEALTH_CARE')&&(
                          <th style={{ color: '#345687' }} className='text-center'>Coding Interviews <br />
                            <div style={{ display: 'flex', flexDirection: 'row', borderTop: '1px solid #8080803d', margin: '0px' }}>
                              <div className="col-6 col-md-6" style={{ borderRight: '1px solid #8080803d', color: '#345687' }}>Scheduled</div>
                              <div className="col-6 col-md-6" style={{ color: '#345687' }}>Completed</div>
                            </div>
                          </th>
                          ) }
                          {(selectCategory !== 'HOSPITALITY' && selectCategory !== 'HEALTH_CARE')&&(
                          <th style={{ color: '#345687' }} className='text-center'> Schedule Interview</th>
                          )}
                          {(selectCategory === 'HOSPITALITY' || selectCategory === 'HEALTH_CARE')&&(
                            <th style={{ color: '#345687' }} className='text-center'> Schedule Interview</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((job, index) => (
                          <YourComponent key={indexOfFirstItem + index} job={job} index={indexOfFirstItem + index} />
                        ))}


                      </tbody>
                    </Table>
                    {/* <div style={{ display: 'flex', justifyContent: 'end' }}>
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        className='page-nation-btn'
                        disabled={currentPage === 1}
                      >
                        Prev
                      </button>

                      {getPageRange().map((page) => (
                        <button
                          key={page}
                          onClick={() => paginate(page)}
                          className='page-nation-btn'
                          style={{
                            backgroundColor: page === currentPage ? '#007BFF' : 'white',
                            color: page === currentPage ? 'white' : 'black',
                          }}
                        >
                          {page}
                        </button>
                      ))}

                      <button
                        onClick={() => paginate(currentPage + 1)}
                        className='page-nation-btn'
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div> */}
                  </div>):(
                    <div>
                      { !loading && isCategory && <Alert variant="danger">No Data Available</Alert>}
                    </div>
                  )
                }
              </Col>
            </Row>
          </div>
        )}
        {/* All Job div end */}

        {/* Manage Client div start */}
        {latestTestFlag && (
          <div className='tables-div'>
            <Row className='tables-div'>
              <Col>
                {success && <Alert variant="danger">{success}</Alert>}
                {loading && (
                  <div className="spinner-overlay">
                    <Spinner animation="border" role="status">
                      <span className="sr-only"></span>
                    </Spinner>
                  </div>
                )}
                {
                  <div className="table-responsive">
                    <ClientsPage />

                  </div>}

              </Col>
            </Row>
          </div>
        )}
        {/* Manage Client div End */}
        {/* Add New Job div start */}
        {
          postJobFlag && (
            <div>
              <AddJobPostPage />
            </div>
          )
        }
        {/* Add New Job div end */}
      </div>
    </div>
  );

}
export default JobPost;